import React from 'react';

class Checkbox extends React.Component {
  render () {
    const { checked } = this.props;
    const className = 'Checkbox' + (checked ? ' checked' : '');
    return (
      <div className={className}> </div>
    )
  }
};

export default Checkbox;



// WEBPACK FOOTER //
// ./client/Core/Components/Checkbox.jsx